export function entityTypePath(entityTypeLabel: string): string {
	let entityTypePath = '';
	switch (entityTypeLabel) {
		case 'Individual':
			entityTypePath = 'individual-account';
			break;
		case 'Joint Account':
			entityTypePath = 'joint-account';
			break;
		case 'Trust':
			entityTypePath = 'trust';
			break;
		case 'Investment Company':
			entityTypePath = 'entity-account';
			break;
		case 'Individual Retirement Account':
			entityTypePath = 'ira';
			break;
	}

	return entityTypePath;
}
export function investmentEntityPath(entityTypeLabel: string, investmentEntityId: string): string {
	const entityType: string = entityTypePath(entityTypeLabel);
	return `/account/investment-accounts/${investmentEntityId}/${entityType}`;
}

export function getAddressLabelsFromCountryCode(countryCode: string): {
	cityLabel: string;
	stateLabel: string;
	zipLabel: string;
} {
	let cityLabel = 'City',
		stateLabel = 'State',
		zipLabel = 'ZIP Code';

	switch (countryCode) {
		case 'CA':
			stateLabel = 'Province';
			zipLabel = 'Postal Code';
			break;
		case 'AU':
			cityLabel = 'City/Town';
			stateLabel = 'State/Territory';
			zipLabel = 'Postcode';
			break;
		case 'GB':
			cityLabel = 'City/Town';
			zipLabel = 'Postcode';
			break;
	}

	return {
		cityLabel,
		stateLabel,
		zipLabel
	};
}
